import React from 'react';
import { connect } from 'react-redux';
import * as uiActions from '../../store/ui/actions';

import styles from './ConfirmationDialog.scss';
import Button from 'Components/Button';

class ConfirmationDialog extends React.PureComponent {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
    this.falseHandler = this.falseHandler.bind(this);
  }

  componentDidMount() {
    window.addEventListener('click', this.handleClick, false);
    window.addEventListener('keyup', this.handleKeyUp, false);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.handleClick);
    window.removeEventListener('keyup', this.handleKeyUp, false);
    this.falseHandler();
  }

  handleKeyUp(e) {
    if (e.key === 'Escape') this.falseHandler();
  }

  handleClick(e) {
    if (e.target.classList.contains('ConfirmationDialog')) this.falseHandler();
    return false;
  }

  falseHandler() {
    const {
      name,
      settings,
      respondToConfirmationDialog,
      clearConfirmationDialog,
    } = this.props;
    const { clearOnFalse } = settings;
    return clearOnFalse
      ? clearConfirmationDialog()
      : respondToConfirmationDialog(name, false);
  }

  render() {
    const { name, settings, respondToConfirmationDialog } = this.props;
    const { title, question, trueLabel, falseLabel } = settings;
    return (
      <div className="ConfirmationDialog">
        <div className="ConfirmationDialog__container">
          <div className="ConfirmationDialog__title">{title}</div>
          <div className="ConfirmationDialog__question">{question}</div>
          <div className="ConfirmationDialog__actions">
            <Button
              label={trueLabel}
              buttonType="secondary-mono"
              clickHandler={() => respondToConfirmationDialog(name, true)}
            />
            <Button
              label={falseLabel}
              buttonType="secondary-transparent"
              clickHandler={() => this.falseHandler()}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default connect(false, uiActions)(ConfirmationDialog);
